import API from 'utils/API';
import http from 'utils/http';

// 发送短信
export function sendSMS(params, platform: 'portal' | 'oauth' = 'oauth', type: 'phone' | 'email' = 'phone') {
    let sendMsgUrl = '';

    if (platform === 'portal') {
        sendMsgUrl = API.PORTAL.sms();
    } else {
        sendMsgUrl = API.OAUTH[type === 'email' ? 'emailCode' : 'phoneCode']();
    }

    return http.post(sendMsgUrl, params, {
        withCredentials: true
    });
}
